import AppImage from "assets/images/mascots/app.png";
import type { MouseEvent } from "react";
import { APP_STORE_URLS } from "shared/config/appStoreUrls";
import { type AppStore, requestAppDownload } from "shared/services/appDownload";
import AppleStoreImage from "assets/images/stories/apple.png";
import GooglePlayImage from "assets/images/stories/google.png";
import {
  BannerContent,
  BannerEyebrow,
  BannerImage,
  BannerText,
  BannerTitle,
  BannerWrapper,
  StoreLink,
  StoreLinks,
} from "./styles";

// Mantém o <a href> (acessibilidade e abrir em nova aba), mas o clique passa
// pelo fluxo da campanha AdvancedBR.
const handleStoreClick =
  (store: AppStore) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    requestAppDownload(store);
  };
/**
 * Faixa de divulgação do aplicativo Voopter exibida abaixo da lista de
 * alertas: chamada para baixar o app, descrição e ilustração.
 */
export const AppBanner = () => (
  <BannerWrapper>
    <BannerContent>
      <BannerEyebrow>Passagens baratas direto na sua mão</BannerEyebrow>
      <BannerTitle>Baixe agora o App da Voopter</BannerTitle>
      <BannerText>
        Com o aplicativo do Voopter, você encontra passagens aéreas mais
        econômicas diretamente do seu celular.
      </BannerText>
      <StoreLinks>
        <StoreLink
          href={APP_STORE_URLS.android}
          target="_blank"
          rel="noreferrer"
          aria-label="Baixar na Google Play"
          onClick={handleStoreClick("android")}
        >
          <img src={GooglePlayImage} alt="Disponível no Google Play" />
        </StoreLink>
        <StoreLink
          href={APP_STORE_URLS.ios}
          target="_blank"
          rel="noreferrer"
          aria-label="Baixar na App Store"
          onClick={handleStoreClick("ios")}
        >
          <img src={AppleStoreImage} alt="Baixar na App Store" />
        </StoreLink>
      </StoreLinks>
    </BannerContent>
    <BannerImage src={AppImage} alt="Aplicativo da Voopter" />
  </BannerWrapper>
);

export default AppBanner;
